// @ts-nocheck
export const ComplianceRequestType = {
  Change: 'change',
  Delete: 'delete',
  View: 'view',
};
